<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row>
              <b-col xl="12" lg="12" sm="12">
                <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                    <b-form @submit.prevent="handleSubmit(register)" @reset.prevent="reset" enctype="multipart/form-data">
                        <b-row>
                            <b-col lg="6" sm="12">
                                <ValidationProvider name="Organization" vid="org_id" rules="required|min_value:1">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="org_id"
                                        slot-scope="{ valid, errors }"
                                        >
                                        <template v-slot:label>
                                        {{$t('globalTrans.organization')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-select
                                        plain
                                        v-model="createCommittee.org_id"
                                        :options="orgList"
                                        id="org_id"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        >
                                        <template v-slot:first>
                                            <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                        </template>
                                        </b-form-select>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col lg="6" sm="12">
                                <ValidationProvider name="Formation Date" vid="formation_date" rules="required">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="formation_date"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                            {{$t('committee.formation_date')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input
                                            class="date-picker"
                                            v-model="createCommittee.formation_date"
                                            placeholder="Select Date"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col lg="6" sm="12">
                                <ValidationProvider name="Committee Name (En)" vid="committee_name" rules="required">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="committee_name"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                            {{$t('committee.committee_name')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input
                                            id="committee_name"
                                            v-model="createCommittee.committee_name"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col lg="6" sm="12">
                                <ValidationProvider name="Committee Name (Bn)" vid="committee_name_bn" rules="required">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="committee_name_bn"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                            {{$t('committee.committee_name_bn')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input
                                            id="committee_name_bn"
                                            v-model="createCommittee.committee_name_bn"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col lg="6" sm="12">
                                <ValidationProvider name="Purpose (En)" vid="purpose" rules="required">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="purpose"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                            {{$t('committee.purpose')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input
                                            id="purpose"
                                            v-model="createCommittee.purpose"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col lg="6" sm="12">
                                <ValidationProvider name="Purpose (Bn)" vid="purpose_bn" rules="required">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="purpose_bn"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <template v-slot:label>
                                            {{$t('committee.purpose_bn')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-input
                                            id="purpose_bn"
                                            v-model="createCommittee.purpose_bn"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col lg="6" sm="12">
                                <ValidationProvider name="Duration" vid="duration" rules="required">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="duration"
                                        slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('committee.committee_duration_with_day')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-input
                                        id="duration"
                                        type="number"
                                        v-model="createCommittee.duration"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col lg="6" sm="12">
                                <ValidationProvider name="Document Name" vid="document_name">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="4"
                                    label-for="document_name"
                                    slot-scope="{ valid, errors }"
                                >
                                <template v-slot:label>
                                    {{$t('committee.document_name')}}
                                </template>
                                <b-form-input
                                    id="document_name"
                                    v-model="createCommittee.document_name"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-form-input>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col lg="6" sm="12">

                                <ValidationProvider name="Attachment" vid="attachment">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        :label="$t('committee.attachment')"
                                        label-for="attachment"
                                        slot-scope="{ valid, errors }"
                                    >
                                        <b-form-file
                                            id="attachment"
                                            v-on:change="onFileChange"
                                            v-model="createCommittee.attachment"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-file>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col lg="6" sm="12"></b-col>
                        </b-row>
                        <b-row v-for="(mamber,index) in createCommittee.committee" :key="index">
                            <b-col lg="6" sm="9">
                                <ValidationProvider name="User Name" vid="user_id" rules="required|min_value:1">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="user_id"
                                        slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('committee.choose_user')}} <span class="text-danger">*</span>
                                    </template>
                                        <b-form-select
                                            plain
                                            v-model="mamber.user_id"
                                            :options="userList"
                                            :id="index"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            >
                                            <template v-slot:first>
                                                <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                            </template>
                                        </b-form-select>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col lg="3" sm="4">
                            <b-button v-show="index == createCommittee.committee.length-1" variant=" iq-bg-success" size="sm" @click="add()"><i class="ri-add-line m-0"></i></b-button>
                            <b-button v-show="index || ( !index && createCommittee.committee.length > 1)" variant=" iq-bg-danger" size="sm" @click="remove(index)"><i class="ri-delete-bin-line m-0"></i></b-button>
                            </b-col>
                            <b-col class="text-right" md="12" sm='12' lg="12" xl="12">
                                <b-button type="submit" variant="primary">{{ saveBtnName}}</b-button>
                                &nbsp;
                                <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </ValidationObserver>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '../../../../../config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { commonServiceBaseUrl, authServiceBaseUrl } from '../../../../../config/api_config'
import { createCommitteeStore, createCommitteeUpdate } from '../../api/routes'
import flatpickr from 'flatpickr'

export default {
  props: ['id'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  created () {
    if (this.id) {
      const tmp = this.getCreateCommitteeData()
    //   Object.freeze(tmp)
      this.createCommittee = tmp
      const committeeData = tmp.committee.map(item => {
        return { user_id: item.user_id }
      })
      this.createCommittee.committee = committeeData
    }
  },
  mounted () {
      flatpickr('.date-picker', {})
      core.index()
  },
  data () {
    return {
        totalPost: 0,
        saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
        createCommittee: {
            org_id: 0,
            committee_name: '',
            committee_name_bn: '',
            formation_date: '',
            purpose: '',
            purpose_bn: '',
            duration: '',
            document_name: '',
            attachment: '',
            committee: [
                {
                    user_id: 0
                }
            ]
        },
        attachmentDemo: '',
        userList: []
    }
  },
  computed: {
    orgList: function () {
      return this.$store.state.orgList.filter(item => item.status === 0)
    }
  },
  watch: {
      'createCommittee.org_id': function (newVal, oldVal) {
      this.userList = this.findUser(newVal)
    }
  },
  methods: {
    getCreateCommitteeData () {
      const tmpData = this.$store.state.list.find(item => item.id === this.id)
      return JSON.parse(JSON.stringify(tmpData))
    },
    onFileChange (e) {
      this.attachmentDemo = e.target.files[0]
    },
    async register () {
      this.$store.dispatch('mutateCommonProperties', { loading: true })
      let result = null
      const loadinState = { loading: false, listReload: true }
      const config = {
        headers: { 'content-type': 'multipart/form-data' }
      }
      var formData = new FormData()
      Object.keys(this.createCommittee).map(key => {
        if (key === 'attachment') {
          formData.append(key, this.attachmentDemo)
        } else {
          formData.append(key, JSON.stringify(this.createCommittee[key]))
        }
      })

      if (this.createCommittee.id) {
        formData.append('_method', 'PUT')
        result = await RestApi.postData(commonServiceBaseUrl, `${createCommitteeUpdate}/${this.id}`, formData, config)
      } else {
        formData.append('created_by', 1)
        result = await RestApi.postData(commonServiceBaseUrl, createCommitteeStore, formData, config)
      }
      this.$store.dispatch('mutateCommonProperties', loadinState)
      if (result.success) {
        this.$store.commit('mutateDropdownCommonConfig', { hasDropdownLoaded: false })
        this.$toast.success({
          title: 'Success',
          message: this.id ? 'Data updated successfully' : 'Data save successfully',
          color: '#D6E09B'
        })
        this.$bvModal.hide('modal-4')
      } else {
        this.$refs.form.setErrors(result.errors)
        this.$toast.error({
          title: 'Error',
          message: 'Operation failed! Please, try again.'
        })
      }
    },
    add () {
        const userName = {
            user_id: 0
        }
        const key1 = parseInt(this.createCommittee.committee.length - 1)
        const item = this.createCommittee.committee[key1]
        let isEmpty = true
        Object.keys(item).map(key => {
            if (item[key] === '' || item[key] === 0) {
                isEmpty = false
            }
        })
        if (isEmpty === true) {
            this.createCommittee.committee.push(userName)
        }
    },
    remove (key) {
      this.createCommittee.committee.splice(key, 1)
    },
    findUser (orgId) {
      RestApi.getData(authServiceBaseUrl, '/user/getAllUser', null).then(response => {
        if (response.success) {
          const userData = response.data.filter(user => user.org_id === orgId)
          this.userList = userData.map((obj, index) => {
            if (this.$i18n.locale === 'bn') {
              return { value: obj.id, text: obj.name_bn }
            } else {
              return { value: obj.id, text: obj.name }
            }
          })
        }
      })
    }
    }
  }

</script>
